import { useSelector } from "react-redux";
import { userSelectedProductlistIdSelector } from "_redux/selectors/user";

const useSelectedProductlistId = () =>
  useSelector(userSelectedProductlistIdSelector);

export default useSelectedProductlistId;
